import { useOutletContext } from "react-router-dom"
import { WxdhRuleStyle } from "./style"
import { ContestDetailResponse } from "types/contest"

const WxdhRule = () => {
    const { detail } = useOutletContext<{ detail: ContestDetailResponse }>()
    const contestJSON = JSON.parse(detail?.pageCfg || "{}")

    const dataList: {
        word: { name: string, id: number, desc: string[] }[],
        designForm: { id: number, title: string, desc: string[], imageList: { id: number, url: string, name: string }[] }[]
        requirement: string[]
        notice: string[]
    } = contestJSON?.rule

    return <WxdhRuleStyle>
        {
            !!detail && <div className="rule">
                <div className="title-wrap">
                    <div className="title">
                        <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-left.png" className="left" />
                        <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-title-one.png" alt="" className="num" />
                        <div className="title-word">
                            <div><span>设</span>计<span>内</span>容</div>
                        </div>
                        <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-right.png" className="right" />
                    </div>
                    <div className="en-word">DESIGN CONTENT</div>
                </div>
                <div className="part part1">
                    <div className="part1-content">
                        {
                            dataList.word.map(item => {
                                return <div className="item" key={item.id}>
                                    {
                                        !!item.name && <div className="name">{item.name}</div>
                                    }
                                    {
                                        item.desc.map(desc => {
                                            return <div className="desc" key={desc}>{desc}</div>
                                        })
                                    }
                                </div>
                            })
                        }
                    </div>
                    <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-icon1.png" className="icon1" />
                    <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-icon2.png" className="icon2" />
                </div>
                <div className="part part2">
                    <div className="title-wrap">
                        <div className="title">
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-left.png" className="left" />
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-title-two.png" alt="" className="num" />
                            <div className="title-word">
                                <div><span>设</span>计<span>形</span>式</div>
                            </div>
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-right.png" className="right" />
                        </div>
                        <div className="en-word">DESIGN FORM</div>
                    </div>
                    <div className="part2-content">
                        {
                            dataList.designForm.map(item => {
                                return <div className="item" key={item.id}>
                                    <div className="name">{item.title}</div>
                                    {
                                        item.desc.map(desc => {
                                            return <div className="desc" key={desc}>{desc}</div>
                                        })
                                    }
                                    {
                                        item.id === 1 && <div className="image">
                                            <div className="image-left">
                                                {
                                                    item.imageList.slice(0, 2).map(img => {
                                                        return <div className="item" key={img.id}>
                                                            <img src={img.url} alt="" />
                                                            <div className="img-name">{img.name}</div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                            <div className="image-right">
                                                {
                                                    item.imageList.slice(2, 3).map(img => {
                                                        return <div className="item" key={img.id}>
                                                            <img src={img.url} alt="" />
                                                            <div className="img-name">{img.name}</div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                        </div>
                                    }
                                    {
                                        item.id === 2 && <div className="image">
                                            <div className="item">
                                                <img src={item.imageList[0].url} alt="" />
                                            </div>
                                        </div>
                                    }

                                </div>
                            })
                        }
                    </div>
                    <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-icon3.png" className="icon3" />
                </div>
                <div className="part part3">
                    <div className="title-wrap">
                        <div className="title">
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-left.png" className="left" />
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-title-three.png" alt="" className="num" />
                            <div className="title-word">
                                <div><span>设</span>计<span>要</span>求</div>
                            </div>
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-right.png" className="right" />
                        </div>
                        <div className="en-word">DESIGN REQUIREMENT</div>
                    </div>
                    <div className="part3-content">
                        {
                            dataList.requirement.map((item, index) => {
                                return <div className="item" key={item}>
                                    <div>{index + 1}、</div>
                                    <div>{item}</div>
                                </div>
                            })
                        }
                    </div>
                </div>
                <div className="part part4">
                    <div className="title-wrap">
                        <div className="title">
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-left.png" className="left" />
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-title-four.png" alt="" className="num" />
                            <div className="title-word">
                                <div><span>设</span>计<span>须</span>知</div>
                            </div>
                            <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-banner-title-right.png" className="right" />
                        </div>
                        <div className="en-word">AWARD NOTICE</div>
                    </div>
                    <div className="part4-content">
                        {
                            dataList.notice.map((item, index) => {
                                return <div className="item" key={item}>
                                    <div>{index + 1}、</div>
                                    <div>{item}</div>
                                </div>
                            })
                        }
                    </div>
                    <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-icon4.png" className="icon4" />
                </div>
                <div className="bottom">
                    <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-border-logo.png" className="bottom-logo" />
                    <div className="bottom-tree">
                        <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-icon5.png" />
                        <img src="https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-icon6.png" />
                    </div>
                </div>
            </div>
        }
    </WxdhRuleStyle>
}

export default WxdhRule